export const METADATA_START_LOAD = 'METADATA_START_LOAD'
export const METADATA_LOADED = 'METADATA_LOADED'
export const METADATA_UPDATE = 'METADATA_UPDATE'
export const METADATA_AUTH_FAILED = 'METADATA_AUTH_FAILED'
export const METADATA_INVALID_SESSION = 'METADATA_INVALID_SESSION'
